<sn-form [form]="form" [fields]="dateFields" [model]="formModel"></sn-form>
<div class="buttons">
  <button color="warn" [matTooltip]="'common.close' | t" mat-icon-button (click)="close()">
    <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
  </button>
  <button
    class="apply-button"
    [matTooltip]="'common.apply' | t"
    mat-icon-button
    [disabled]="!isValid"
    (click)="onDateChange()"
  >
    <sn-icon fontSet="fal" fontIcon="fa-check"></sn-icon>
  </button>
</div>
